import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('games')

const state = {
  data: null,
  loading: false
}

const getters = {

  instructions (state) {
    return state.data ? state.data.params.instructions.list : []
  },

  skipInstructions (state) {
    return state.data ? state.data.params.skipInstructions : false
  },

  test (state) {
    return state.data ? state.data.params.test : false
  },

  maxOrder (state) {
    return state.data ? state.data.params.maxOrder : 200
  },

  debrief (state) {
    return state.data ? state.data.debrief : false
  },

  assignableCompanies (state) {
    return state.data ? [...state.data.companies].filter((company) => company.assignable).sort((a, b) => a.level - b.level) : [] 
  },

  companies (state) {
    return state.data ? [...state.data.companies].sort((a, b) => a.level - b.level) : [] 
  },

  code: state => {
    return state.data !== null ? state.data.code : ""
  },

  suspended: state => {
    return state.data !== null ? state.data.suspended : false
  },

  finish: (state, getters, rootState, rootGetters) => {
    if (!state.data) return false
    let answer = true
    if (state.status == 2 && rootState.company.data.step == 7) {
      state.data.companies.filter((comp) => comp.assignable).forEach(company => {
        if (company.week > rootGetters['company/week']) {
          answer = false
        }
      });
    } else {
      return false
    }
    return answer
  },

  timer: state => {
    return state.data !== null ? state.data.params.dayTimer : false
  },
  
  timerCount: state => {
    return state.data !== null ? state.data.params.dayTimerCount : 0
  },

  status: state => {
    return state.data !== null ? state.data.status : 1
  },

  ready: state => {
    if (!state.data) return false
    let answer = true
    state.data.companies.forEach(company => {
      if (company.assignable && !company.ready) {
        answer = false
      }
    })
    return answer
  },

  nextWeekReady: (state, getters, rootState, rootGetters) => {
    if (!state.data) return false
    let answer = true
    state.data.companies.filter((comp) => comp.assignable).forEach(company => {
      if (company.week < rootGetters['company/week'] || ( company.week == rootGetters['company/week'] && company.step < 7)) {
        answer = false
      }
    });
    return answer
  }

}

const actions = {

  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_loading', false)
      commit('SET_game', res.data)
      return true
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  SOCKET_playerUpdate ({commit}, val) {
    commit('UPDATE_game', val.company)
  },

  SOCKET_gameUpdate ({commit}, val) {
    commit('SET_game', val)
  }

}

const mutations = {

  SET_game(state, val) {
    state.data = val
  },

  UPDATE_game(state, val) {
    for (let index = 0; index < state.data.companies.length; index++) {
      if (state.data.companies[index]._id.toString() === val._id.toString()) {
        state.data.companies.splice(index, 1, val)
        break
      }
    }
  },

  SET_loading(state, val) {
    state.loading = val
  }
  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}